<template>
  <v-navigation-drawer
    :mini-variant="miniVariant"
    :clipped="clipped"
    v-model="drawer"
    class
    id="app-drawer"
    style="background: transparent;position:relative;top:-15px"
  >
    <!--<v-img :src="image" height="100%">-->

    <v-layout class="fill-height c-thru-green" tag="v-list" column>
      <v-list-tile avatar class="mt-5 mb-5">
        <v-layout column wrap class="mt-4" align-center justify-center>
          <!--<v-icon x-large style="font-size: 77px;color: #0ec186 !important;padding-top: 48px;text-shadow: 2px 2px 6px #bec1c0;">polymer</v-icon>-->
          <img
            src="../../assets/lingoLogoGreen2.png"
            style="transform: scale(0.68);position: relative;top: 17px;cursor:pointer"
            class="drawerLogo"
            @click="home()"
          />
          <div class="font-weight-light" style="color: rgb(38, 39, 39);font-size: 1.5rem;">Lingo AV</div>
        </v-layout>
      </v-list-tile>
      <v-divider class="drawer-divider" />
      <v-list class="drawer-list">
        <v-list-tile
          v-for="(item, i) in items"
          :key="i"
          :to="item.link"
          active-class="drawer-item-selected"
          class
        >
          <v-list-tile-action>
            <v-icon class="drawer-icon">{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title
              class="font-weight-light drawer-item-title"
              style="color:#3c4858"
            >{{ item.text }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-layout>

    <!-- </v-img>-->
  </v-navigation-drawer>
</template>

<style>
.drawerLogo:hover {
  transform: scale(0.68) rotate(360deg) !important;
  transition: transform 0.8s;
}

.v-navigation-drawer__border {
  display: none !important;
}
.logo-shadow {
  --text-shadow: 2px 3px 3px #eaeaeaf2 !important;
}

.c-thru-green {
  --background-color: #20322096 !important;
  background: transparent !important;
  --box-shadow: inset -11px -3px 18px -15px rgb(53, 154, 162);
}

.drawer-list {
  background: transparent !important;
  color: #464646 !important;
  margin-top: 6rem;
}

.drawer-icon {
  padding-left: 10px;
  color: #a9afbb !important;
}

.drawer-divider {
  border-color: #e7eaed !important;
  position: relative;
  top: 50px;
}

.drawer-item-selected {
  background-color: #e6eaec !important;
  --border-left: 4px solid #15b681;
  box-shadow: inset rgba(222, 222, 222, 0.67) 1px 0px 4px 2px;
  --border: 1px dotted #bbb1b1;
}

.drawer-item-selected i {
  color: unset !important;
}

.drawer-item-selected .drawer-item-title {
  font-weight: bold !important;
}

#app-drawer .v-list__tile {
  --border-radius: 4px;
}
</style>

<script>
import { Auth } from "./auth/cognito_auth";

export default {
  name: "lingo_drawer",
  data() {
    var _data = {
      image:
        "https://wallpaper.wiki/wp-content/uploads/2017/05/wallpaper.wiki-Download-Free-Music-Note-Image-PIC-WPD001644.jpg",
      clipped: false,
      drawer: true,
      fixed: false,
      items: [
        {
          icon: "voicemail",
          text: "AUDIO GENERATOR",
          link: "/app/audio_generator"
        },
        /*{ icon: 'video_library', text: 'VIDEO GENERATOR', link : '/app/video_generator' },*/
        { icon: "library_books", text: "MY FILES", link: "/app/my_files" }
        /*{ icon: 'star_border', text: 'FAVORITE VOICES', link : '/app/favorites' },*/
        /*{ icon: "video_library", text: "TEST VIEW", link: "/app/audio_test" }*/

        /* { icon: 'keyboard', text: 'Presets', link : '/app/generate' },
        { icon: 'keyboard', text: 'History', link : '/app/generate' },
        { icon: 'keyboard', text: 'Samples', link : '/app/gallery' }*/
      ],
      miniVariant: false,
      right: false,
      rightDrawer: false,
      title: "Lingo AV"
    };
    if (!this.isUserLoggedIn()) {
      _data.items.splice(1, 1);
    }
    return _data;
  },
  methods: {
    isUserLoggedIn() {
      return Auth.isUserLoggedIn();
    },
    home() {
    	if (!this.isUserLoggedIn()) {
    		this.$router.push({path: '/'});
    	}
    }
  }
};
</script>
